import commonMutations from '@/store/data/common/mutations'
import Vue from 'vue'
import { isNil, find, findIndex } from 'lodash'
import helpers from './helpers'

const mutations = {
    ...commonMutations,
    setCcloneDetails(state, { items, ccloneId }) {
        Vue.set(state, 'ccloneDetails', {
            ...state.ccloneDetails,
            [ccloneId]: {
                ...items,
                selectedPoint: []
            }
        })
    },

    setDecisionTree(state, { status, image }) {
        Vue.set(state.decisionTree, 'status', status)
        Vue.set(state.decisionTree, 'image', image)
    },

    setSelectedPoint(state, { ccloneId, data }) {
        Vue.set(state.ccloneDetails[ccloneId], 'selectedPoint', data)
    },

    setSelectedPointLabel(state, { label }) {
        Vue.set(state, 'selectedPointLabel', label)
    },
    setUpdatedCclone(state, { item }) {
        const _cclones = state.list
        const ccloneFromStore = find(_cclones, ccl => ccl.id === item.id)

        if (!isNil(ccloneFromStore)) {
            let parsedItem = helpers.parseUpdatedCclone(item)
            parsedItem = { ...parsedItem, scf_raw_data_result: ccloneFromStore.scf_raw_data_result }

            const _elemIndex = findIndex(_cclones, cclone => cclone.id === parsedItem.id)
            _cclones.splice(_elemIndex, 1, parsedItem)

            Vue.set(state, 'list', _cclones)
        }
    }
}

export default mutations
